export default __webpack_public_path__ + "static/media/954.74092a53.gif";